/** Warengruppen sind mandantenspezifisch; die Liste dient nur als Sortier-/Filterbasis. */
export const PRODUCT_TAG_MAX_LENGTH = 40;
export const PRODUCT_TAGS_MAX_COUNT = 20;
/** Zulässige Sortierspalten der Artikelliste — begrenzt, weil sie direkt in die Query fließen. */
export const PRODUCT_SORT_FIELDS = [
    'articleNumber',
    'name',
    'productGroup',
    'status',
    'stockQuantity',
    'listPrice',
    'createdAt',
    'updatedAt',
];
/**
 * UN/CEFACT-Einheitencodes, die im Stammdatendialog angeboten werden.
 * Die Basiseinheit eines Artikels ist nach der ersten Buchung unveränderlich.
 */
export const UNIT_CODES = ['PCE', 'KGM', 'GRM', 'LTR', 'MLT', 'MTR', 'MTQ', 'MTK', 'PA'];
/** Kurzbezeichnungen für serverseitig erzeugte deutsche Texte (Meldungen, PDF). */
const UNIT_SHORT_LABELS = {
    PCE: 'Stück',
    KGM: 'kg',
    GRM: 'g',
    LTR: 'l',
    MLT: 'ml',
    MTR: 'm',
    MTQ: 'm³',
    MTK: 'm²',
    PA: 'Paket',
};
export function unitShortLabel(code) {
    return UNIT_SHORT_LABELS[code] ?? code;
}
/** Gebindearten (Verpackungsstufen) über der Basiseinheit. */
export const PACKAGING_UNIT_CODES = ['BX', 'CT', 'PF', 'PK', 'TU', 'BG', 'CS'];
/**
 * Ampelschwellen der MHD-Überwachung in Tagen (docs/SPEC.md 3.5).
 * Rot: abgelaufen oder Restlaufzeit unter `CRITICAL`, Gelb: unter `WARNING`.
 */
export const SHELF_LIFE_CRITICAL_DAYS = 30;
export const SHELF_LIFE_WARNING_DAYS = 90;
export const EXPIRY_LEVELS = ['EXPIRED', 'CRITICAL', 'WARNING', 'OK'];
/** Obergrenze für die Massenpreispflege in einem Request. */
export const PRICE_UPDATE_MAX_PRODUCTS = 500;
/** Höchstzahl Staffelpreise bzw. Gebinde je Artikel; verhindert unbegrenzte Payloads. */
export const PRICE_TIERS_MAX_COUNT = 50;
export const PACKAGINGS_MAX_COUNT = 20;
/** Menge, ab der eine Bestandskorrektur zusätzlich begründet werden muss, ist immer gegeben. */
export const STOCK_ADJUSTMENT_REASON_MIN_LENGTH = 5;
// ---------------------------------------------------------------------------
// Product images, categories, and catalog
// ---------------------------------------------------------------------------
/** Hard upload limits shared by the API and web application. */
export const PRODUCT_IMAGE_MAX_FILE_BYTES = 20 * 1024 * 1024;
export const PRODUCT_IMAGE_MAX_DIMENSION = 12_000;
export const PRODUCT_IMAGE_MAX_PIXELS = 100_000_000;
export const PRODUCT_IMAGES_MAX_COUNT = 20;
export const PRODUCT_IMAGE_TITLE_MAX_LENGTH = 200;
export const PRODUCT_IMAGE_ALT_TEXT_MAX_LENGTH = 500;
export const PRODUCT_IMAGE_FORMATS = ['jpeg', 'png', 'webp', 'avif'];
export const PRODUCT_IMAGE_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/avif',
];
export const PRODUCT_IMAGE_VARIANTS = ['thumbnail', 'list', 'catalog', 'detail'];
export const PRODUCT_IMAGE_PROCESSING_STATUSES = [
    'PENDING',
    'PROCESSING',
    'READY',
    'FAILED',
];
export const PRODUCT_IMAGE_VARIANT_SPECS = {
    thumbnail: { width: 96, height: 96, quality: 76 },
    list: { width: 160, height: 160, quality: 78 },
    catalog: { width: 480, height: 480, quality: 82 },
    detail: { width: 1_200, height: 1_200, quality: 86 },
};
export const PRODUCT_CATEGORY_NAME_MAX_LENGTH = 120;
export const PRODUCT_CATEGORY_DESCRIPTION_MAX_LENGTH = 2_000;
export const PRODUCT_CATEGORY_SLUG_MAX_LENGTH = 160;
export const PRODUCT_CATALOG_PAGE_SIZE_DEFAULT = 24;
export const PRODUCT_CATALOG_PAGE_SIZE_MAX = 200;
export const PRODUCT_CATALOG_SORTS = [
    'name:asc',
    'name:desc',
    'articleNumber:asc',
    'articleNumber:desc',
    'price:asc',
    'price:desc',
    'stock:asc',
    'stock:desc',
    'lastUsed:desc',
    'updatedAt:desc',
];
//# sourceMappingURL=products.js.map